exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-system-tsx": () => import("./../../../src/pages/system.tsx" /* webpackChunkName: "component---src-pages-system-tsx" */),
  "component---src-templates-character-tsx": () => import("./../../../src/templates/character.tsx" /* webpackChunkName: "component---src-templates-character-tsx" */),
  "component---src-templates-story-tsx": () => import("./../../../src/templates/story.tsx" /* webpackChunkName: "component---src-templates-story-tsx" */)
}

